import { gql } from '@/__generated__';

export const upsertRefundDocument = gql(/* GraphQL */ `
  mutation UpsertRefund(
    $where: RefundWhereUniqueInput!
    $create: RefundCreateInput!
    $update: RefundUpdateInput!
  ) {
    upsertRefund(where: $where, create: $create, update: $update) {
      id
      status
      reason
      note
      amount
      iban
      customerId
      createdAt
      updatedAt
    }
  }
`);

export const updateRefundDocument = gql(/* GraphQL */ `
  mutation UpdateRefund($where: RefundWhereUniqueInput!, $data: RefundUpdateInput!) {
    updateRefund(where: $where, data: $data) {
      id
      status
      reason
      note
      amount
      iban
      customerId
      createdAt
      updatedAt
    }
  }
`);
